import { onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

export function useFocusOnQueryField() {
    const route = useRoute();
    const router = useRouter();

    function focusOnQueryField() {
        const { name, query } = route;

        if (query.field) {
            const field = document.getElementById(query.field);
            if (field) {
                field.scrollIntoView({ behavior: "smooth" });
                setTimeout(() => {
                    const fieldToFocus =
                        field.querySelector("input") ||
                        field.querySelector("textarea") ||
                        field.querySelector("[contenteditable]");
                    if (fieldToFocus) {
                        fieldToFocus.focus();
                    }
                }, 100);
            } else {
                console.warn(`Element with ID '${query.field}' not found.`);
            }
            setTimeout(() => {
                const newQuery = { ...query };
                delete newQuery.field;
                router.replace({ name, query: newQuery });
            }, 50);
        }
    }

    onMounted(() => {
        watch(() => route.query.field, focusOnQueryField, {
            immediate: true,
        });
    });
}
